module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }), _vm._v("CHAPTER TWO")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("“W")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HAT")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("’")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("S")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("WRONG")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("?” ")]), _vm._v("Fifty-six-year-old\n\t\t\t\t\tRose Sanderson frowned. The expression did nothing to mar her exquisite beauty.\n\t\t\t\t\tJust as all the years of anguish had never done.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As long as Emma didn’t look in her mother’s eyes. There wasn’t\n\t\t\t\t\ta lot of beauty there anymore. Only worry. Angst. Sadness. And pain.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Sit down, Mom.” Emma pulled out one of the metal-rimmed\n\t\t\t\t\tNaugahyde chairs in her mother’s kitchen—chairs that matched the metal-rimmed\n\t\t\t\t\tFormica-topped table that had been in that same exact place in the same exact\n\t\t\t\t\thouse for the past twenty-five years.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Emma had been able to convince her mother to update the rest of\n\t\t\t\t\tthe house over the years. But not that table. It was the last place that Rose\n\t\t\t\t\thad seen her baby girl alive—kneeling on one of those chairs at that table\n\t\t\t\t\teating her breakfast like a “big people.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rose wouldn’t change that table, and she would never move—no\n\t\t\t\t\tmatter how much the neighborhood changed. Rose couldn’t leave the only place\n\t\t\t\t\tClaire would know to come back to.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As though she would remember; Claire had been two when she was\n\t\t\t\t\tabducted.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rose’s crystalline blue eyes were wide and worried as Emma sat\n\t\t\t\t\tand folded her hands at the table. “Tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She had to tell her mother about Detective Miller’s phone\n\t\t\t\t\tcalls. Most particularly the last one.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d been deliberating for a couple of days about what she was\n\t\t\t\t\tgoing to say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tonight, with Rob’s infidelity a fresh and burning sting, she\n\t\t\t\t\tcouldn’t seem to find the usual decorum, the caution, with which she couched\n\t\t\t\t\teverything she told her mother.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She didn’t recognize herself in the woman who was pushing her\n\t\t\t\t\tto do something more. To be something different.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("To change what Rose wouldn’t have changed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve spent my entire life playing it safe.” They weren’t the\n\t\t\t\t\twords she’d come to say.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rose’s frown deepened. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I settle,” Emma said. “Or maybe I don’t, I don’t know.” This\n\t\t\t\t\twas her mother. She could only say so much.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Or stray too far from herself…")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was in no state to tell her mother about Ramsey Miller’s\n\t\t\t\t\tphone call—about the horrible mistake she and Rose had made, believing all these\n\t\t\t\t\tyears that Frank Whittier, her mother’s fiancé at the time, had abducted\n\t\t\t\t\tClaire.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I broke up with Rob today.” And that was not a mistake. No\n\t\t\t\t\tmatter how badly Rose took the news.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rose’s eyes held a spark of…something…as she watched Emma,\n\t\t\t\t\tsaying nothing. But the woman wasn’t falling apart so Emma continued.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I came home and found him with another woman in our bed. I\n\t\t\t\t\tgave him until tomorrow morning to get out.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rose nodded. ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her mother’s expression wasn’t crumpling. Or, worse, filling\n\t\t\t\t\twith fear. She almost had a hint of a smile on her face. And she was\n\t\t\t\t\tnodding!")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Had the whole world gone mad? Or only Emma’s portion of it?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What? You knew he was seeing someone?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Of course not. I’d have told you if I’d known that. I just\n\t\t\t\t\tknew he wasn’t right for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("That almost made her angry. As angry as she could ever get with\n\t\t\t\t\tthe woman who’d suffered so horribly. And tried so hard to love Emma enough.\n\t\t\t\t\t“You thought Rob was wrong for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes.” Rose squeezed her hand. “But regardless of what I\n\t\t\t\t\tthought, you loved him and you most definitely didn’t deserve to be cheated on.\n\t\t\t\t\tI know it hurts and I’m so sorry about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Shaking her head, Emma ignored the compassion in her mother’s\n\t\t\t\t\tvoice. This was no time to open her heart and give in to the weakness there—a\n\t\t\t\t\tdesperate need to be loved, in spite of everything.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was better off if she kept her walls up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why didn’t you say anything?” She concentrated on the facts\n\t\t\t\t\tthat perplexed more than they caused pain.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Because I knew you’d figure it out on your own and that you\n\t\t\t\t\twould be so much stronger for having done so. Acting on my say-so could have\n\t\t\t\t\tcrippled you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’d have married him, Mom.” If Rob hadn’t kept putting off\n\t\t\t\t\tchoosing a date. A location. Colors. Anything at all to do with them actually\n\t\t\t\t\tsaying “I do,” rather than just “I’m going to.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rose shook her head. “I don’t think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But if I had? You’d have let me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rose studied her and then said, “I’m not sure. There was always\n\t\t\t\t\tthe chance that I was wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You liked him. From the first time we met him at that\n\t\t\t\t\tfingerprinting clinic, you liked how he took a real interest in our quest.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He was a big help. And had good ideas. He was a pleasant\n\t\t\t\t\tconversationalist, but that doesn’t mean I thought he’d make you happy. I did\n\t\t\t\t\tlike that he kept you here in the area, close by. I liked that he was willing to\n\t\t\t\t\tspend time with us together. That we could do family things.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A given. Rose had lost one daughter. And ever since that day,\n\t\t\t\t\tuntil Emma had met Rob, it had always been just the two of them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not going to leave you, Mom, you know that,” Emma said.\n\t\t\t\t\t“Not for anything, or anyone.” But for the first time, the words didn’t flow\n\t\t\t\t\tfrom her heart as easily as they flowed past her throat.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For the first time, she wished, just for a second, that she\n\t\t\t\t\tcould be as free as other women her age.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And then, ashamed of herself, she gave her mother a hug.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Emma missed Claire like she’d miss an arm or a leg. And she’d\n\t\t\t\t\tonly been four when her little sister had been taken. Rose, a single mother\n\t\t\t\t\twho’d lost her baby, had suffered so much more.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Emma’s job, as the one left behind, was to be there for Rose.\n\t\t\t\t\tPeriod.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wasn’t herself right then. Who knew, maybe she wouldn’t\n\t\t\t\t\tever be exactly herself again. But her role in her mother’s life would not—could\n\t\t\t\t\tnot—change.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Never say never, Em. You have a life to live,” Rose said,\n\t\t\t\t\tsadness mingling with the compassion in her tone. “You have to go where it takes\n\t\t\t\t\tyou.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“My place is here. With you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I hope it is. But if it’s not, you have to go.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her mother was talking crazy. She wasn’t going anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t mean that. You need me here.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes.” Rose’s expression was completely sober. “But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" life doesn’t take precedence over yours. Or it\n\t\t\t\t\tshouldn’t. And I’ve begun to see that maybe, in spite of all of my intentions to\n\t\t\t\t\tthe contrary, it has.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Emma didn’t know what to say. Her mother was right about one\n\t\t\t\t\tthing. She did have a life to live. And she hadn’t been living it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Any other time her mother’s words would have frightened her.\n\t\t\t\t\tTonight, they seemed to make a confusing kind of sense.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("C")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HRIS")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("SKIPPED")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("CHURCH")]), _vm._v(" meal that\n\t\t\t\t\tfollowed the funeral, though he did keep his head low—in deference to his mother\n\t\t\t\t\twho would be disappointed in his manners if she were still alive—as he made his\n\t\t\t\t\tway back to the new black Ford truck he’d bought the previous spring.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wasn’t in a hurry to be anywhere. Late-afternoon sunshine\n\t\t\t\t\tusually signaled waiting his turn to meet with Manny, Comfort Cove’s lobster\n\t\t\t\t\tdealer, and exchange the day’s catch for the current pitiful rate of three\n\t\t\t\t\tdollars per pound. And then there were always things to do on board the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Son Catcher")]), _vm._v(" to occupy his time until dusk—like keeping\n\t\t\t\t\tthe aging engine running until the economy recovered enough to shoot lobster\n\t\t\t\t\tprices back up to a price lobstermen could afford to work for.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Today, for the first time in memory, the dock didn’t call to\n\t\t\t\t\thim. His first Friday off in months and, while he missed the water, the\n\t\t\t\t\texertion, the thrill of the catch, the dock was not a happy place that day.\n\t\t\t\t\tThey’d lost one of their own.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It could happen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Wayne Ainge had been far too young to die. By all accounts he’d\n\t\t\t\t\tworshipped the ocean. And she’d been fickle to him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He might have been driving aimlessly, but Chris’s new truck\n\t\t\t\t\talready seemed to know Chris. Without any conscious decision making, he ended up\n\t\t\t\t\tat Citadel’s, an upscale lounge and eatery in the middle of Main Street, the\n\t\t\t\t\tpart of the tourist district the city council had sunk all the city’s money\n\t\t\t\t\tinto.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Fishermen didn’t frequent Main Street.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Chris parked in his usual Friday-night spot—albeit a few hours\n\t\t\t\t\tearlier than normal—and, pausing to check out the thronging visitors on both\n\t\t\t\t\tsides of the street he slowly pocketed his keys, went inside and took a seat at\n\t\t\t\t\tthe bar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He was one of two people there. The other, a woman of\n\t\t\t\t\tindiscriminate age, eyed him up and down as though analyzing how much he’d bring\n\t\t\t\t\tper pound.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hey, Chris, what’s up?” Cody, the bartender, distracted him\n\t\t\t\t\tfrom a mental rundown of random ways to avoid hookers. “I’ve never seen you in\n\t\t\t\t\there before dark.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Day off work,” Chris said, shrugging, and then remembered his\n\t\t\t\t\tattire. He looked just as he always did on Friday nights—like a white-collar\n\t\t\t\t\tbusiness man relaxing after a long week of work. Not like a man from the docks\n\t\t\t\t\tafter a long hard day. “Pour me a double,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A good bartender, Cody reached for the bottle of high-end\n\t\t\t\t\tscotch that Chris favored and poured twice the amount of Chris’s preferred drink\n\t\t\t\t\twithout saying another word.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tipping his glass to the younger man, Chris sipped, in memory\n\t\t\t\t\tof a twenty-year-old kid he’d barely known. And to men that he’d known all his\n\t\t\t\t\tlife. Fellow lobstermen, fishermen, who risked their lives every day earning a\n\t\t\t\t\tliving in spite of the vagaries of an ocean that was more powerful than all of\n\t\t\t\t\tthem.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And halfway through the glass of amber liquid, he drank to her,\n\t\t\t\t\ttoo. To the mighty Atlantic. The ocean. The reason he would never have a woman\n\t\t\t\t\tin his life.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623409d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 81
// module chunks = 0